export function calcFixedVirtualInfo ({
    offset = 0, // 滚动偏移量
    visibleSize = 0, // 可滚动区域
    bufferSize = 1, // 缓冲区
    itemSize, // item大小
    itemCount, // item总数
}) {
    // 防止offset越界
    offset = Math.min(offset, itemSize * itemCount - visibleSize);

    let startViewIndex = Math.max(0, Math.floor(offset / itemSize)),
        endViewIndex = Math.min(itemCount - 1, Math.floor((offset + visibleSize) / itemSize)),
        startRenderIndex = Math.max(0, startViewIndex - bufferSize),
        endRenderIndex = Math.min(itemCount - 1, endViewIndex + bufferSize),
        topBlank = startRenderIndex * itemSize,
        bottomBlank = itemSize * itemCount - (endRenderIndex + 1) * itemSize,
        topBlankCount = startRenderIndex,
        bottomBlankCount = itemCount - endRenderIndex - 1;

    // console.log({ startViewIndex, endViewIndex, startRenderIndex, endRenderIndex, topBlank, bottomBlank });
    
    return { startViewIndex, endViewIndex, startRenderIndex, endRenderIndex, topBlank, bottomBlank, topBlankCount, bottomBlankCount, totalSize: itemSize * itemCount };
}

export function calcVariableVirtualInfo ({ 
    offset = 0, // 滚动偏移量
    visibleSize = 0, // 可滚动区域
    bufferSize = 1, // 缓冲区
    itemsSize, // 每一项的大小
}) {

    let { itemOffsets, totalSize } = itemsSize.reduce(({ itemOffsets, totalSize }, height) => {
        itemOffsets.push(totalSize);
        totalSize += height;
        return { itemOffsets, totalSize };
    }, { itemOffsets: [], totalSize: 0 });

    // 防止offset越界
    offset = Math.min(offset, totalSize - visibleSize);

    let itemCount = itemOffsets.length;
    // 二分查找
    let low = 0, high = itemCount - 1, startViewIndex = 0, currentOffset;
    while (low <= high) {
        const middle = low + Math.floor((high - low) / 2);
        currentOffset = itemOffsets[middle];
    
        if (currentOffset === offset) {
            startViewIndex = middle;
            break;
        } else if (currentOffset < offset) {
            low = middle + 1;
        } else if (currentOffset > offset) {
            high = middle - 1;
        }
    }

    if (low > high && low > 0) {
        startViewIndex = low - 1;
    }
    
    let endViewIndex = startViewIndex;
    while (endViewIndex < itemCount && itemOffsets[endViewIndex] + itemsSize[endViewIndex] <= offset + visibleSize) {
        endViewIndex++;
    }

    let startRenderIndex = Math.max(0, startViewIndex - bufferSize),
        endRenderIndex = Math.min(itemCount - 1, endViewIndex + bufferSize),
        topBlank = itemOffsets[startRenderIndex],
        bottomBlank = totalSize - itemOffsets[endRenderIndex] - itemsSize[endRenderIndex],
        topBlankCount = startRenderIndex,
        bottomBlankCount = itemCount - endRenderIndex - 1;

    // console.log({ startViewIndex, endViewIndex, startRenderIndex, endRenderIndex, topBlank, bottomBlank });
    
    return { startViewIndex, endViewIndex, startRenderIndex, endRenderIndex, topBlank, bottomBlank, topBlankCount, bottomBlankCount, totalSize };
}